import React from "react";
import { Button } from "@mui/material";
import PropTypes from "prop-types";


const KanbanRatingButton = (props) => {
  return (
    <>
      <Button
        variant="outlined"
        size="small"
        className={"kanban is-rating-button is-rating-button-" + props.type + (props.isActive ? "-active" : "")}
        style={{ fontWeight: '800', boxShadow: 'none', borderRadius: '10px' }}
        onClick={() => {
          props.toggleRating(props.index);
        }}
      >
        {props.type == 'x' ? '-' : props.type.toUpperCase()}
      </Button>
    </>
  );
}

KanbanRatingButton.propTypes = {
  type: PropTypes.string,
  index: PropTypes.number,
  toggleRating: PropTypes.func,
  isActive: PropTypes.bool
};

export default KanbanRatingButton;